(() => {
  const galleries = document.querySelectorAll('[id^="Air68Purchase-"]');

  galleries.forEach((root) => {
    if (root.dataset.galleryReady === "true") return;
    root.dataset.galleryReady = "true";

    const gallery = root.querySelector(".air-gallery");
    const image = root.querySelector("[data-gallery-image]");
    const label = root.querySelector(
      ".air-gallery-footer > p[data-gallery-label]",
    );
    const count = root.querySelector("[data-gallery-count]");
    const thumbs = Array.from(root.querySelectorAll("[data-gallery-thumb]"));
    const variantOptions = Array.from(root.querySelectorAll(".variant_option"));
    const previous = root.querySelector(".air-gallery-arrow-left");
    const next = root.querySelector(".air-gallery-arrow-right");

    if (!gallery || !image || thumbs.length === 0) return;

    const items = thumbs.map((thumb) => {
      const thumbImage = thumb.querySelector("img");
      return {
        color: thumb.dataset.galleryColor,
        label: thumb.dataset.galleryLabel,
        alt: thumb.dataset.galleryAlt,
        transparent: thumb.dataset.galleryTransparent === "true",
        src: thumbImage ? thumbImage.src : "",
        thumb,
      };
    });

    let currentIndex = Math.max(
      0,
      items.findIndex((item) => item.color === root.dataset.initialColor),
    );

    const syncVariantState = () => {
      variantOptions.forEach((variantOption) => {
        const input = variantOption.querySelector(".productOption");
        variantOption.classList.toggle(
          "is-selected",
          Boolean(input && input.checked),
        );
      });
    };

    const show = (index) => {
      currentIndex = (index + items.length) % items.length;
      const item = items[currentIndex];

      image.src = item.src;
      image.alt = item.alt;
      image.classList.toggle("is-transparent", item.transparent);
      gallery.classList.remove("air-gallery-white", "air-gallery-silver");
      gallery.classList.add(`air-gallery-${item.color}`);

      if (label) label.textContent = item.label;
      if (count) {
        count.textContent = `${String(currentIndex + 1).padStart(2, "0")} / ${String(items.length).padStart(2, "0")}`;
      }

      items.forEach((entry, entryIndex) => {
        const selected = entryIndex === currentIndex;
        entry.thumb.classList.toggle("is-active", selected);
        entry.thumb.setAttribute("aria-pressed", selected ? "true" : "false");
      });
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener("click", () => show(index));
    });

    if (previous) {
      previous.addEventListener("click", () => show(currentIndex - 1));
    }

    if (next) {
      next.addEventListener("click", () => show(currentIndex + 1));
    }

    root.addEventListener("change", (event) => {
      const option = event.target.closest(".productOption");
      if (!option) return;

      syncVariantState();

      const value = String(option.value || option.title || "").toLowerCase();
      const matchingColor =
        value.includes("silver") ||
        value.includes("grey") ||
        value.includes("gray")
          ? "silver"
          : value.includes("white")
            ? "white"
            : "";

      if (!matchingColor) return;

      const matchIndex = items.findIndex(
        (item) => item.color === matchingColor,
      );
      if (matchIndex >= 0) show(matchIndex);
    });

    syncVariantState();
    show(currentIndex);
  });
})();
